module.exports = "<ul #sidenav id=\"slide-out\" class=\"{{ class }} side-nav\" >\n  <ng-content></ng-content>\n  <!-- <div class=\"sidenav-bg mask-strong\"></div>     -->\n</ul>\n<div (click)=\"hide()\" #overlay id=\"sidenav-overlay\" style=\"display: none;\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/sidenav/sidenav.component.html
// module id = ./src/app/typescripts/pro/sidenav/sidenav.component.html
// module chunks = main